/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_points_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy points are scored across multiple sessions each weekend: qualifying, race, and sprint (on sprint weekends). Each session awards points for finishing position, with bonuses for overtakes, fastest lap, and Driver of the Day.`)
};

const es_f1_points_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los puntos de fantasy se otorgan en múltiples sesiones cada fin de semana: clasificación, carrera y sprint (en fines de semana de sprint). Cada sesión otorga puntos por posición de llegada, con bonificaciones por adelantamientos, vuelta rápida y Piloto del Día.`)
};

const de_f1_points_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy-Punkte werden über mehrere Sessions jedes Wochenende vergeben: Qualifying, Rennen und Sprint (an Sprint-Wochenenden). Jede Session vergibt Punkte für die Platzierung, mit Boni für Überholmanöver, schnellste Runde und Fahrer des Tages.`)
};

const nl_f1_points_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy-punten worden toegekend over meerdere sessies elk weekend: kwalificatie, race en sprint (op sprintweekenden). Elke sessie kent punten toe voor finishpositie, met bonussen voor inhaalacties, snelste ronde en Coureur van de Dag.`)
};

const fr_f1_points_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les points fantasy sont attribués lors de plusieurs sessions chaque week-end : qualification, course et sprint (les week-ends de sprint). Chaque session accorde des points pour la position d’arrivée, avec des bonus pour les dépassements, le tour le plus rapide et le Pilote du Jour.`)
};

const it_f1_points_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I punti fantasy vengono assegnati in più sessioni ogni weekend: qualifica, gara e sprint (nei weekend sprint). Ogni sessione assegna punti per la posizione di arrivo, con bonus per sorpassi, giro più veloce e Pilota del Giorno.`)
};

const pt_br2_f1_points_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os pontos fantasy são distribuídos em várias sessões cada fim de semana: classificação, corrida e sprint (em fins de semana de sprint). Cada sessão dá pontos pela posição de chegada, com bônus por ultrapassagens, volta mais rápida e Piloto do Dia.`)
};

const pt_f1_points_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os pontos fantasy são atribuídos em várias sessões cada fim de semana: qualificação, corrida e sprint (em fins de semana de sprint). Cada sessão atribui pontos pela posição de chegada, com bónus por ultrapassagens, volta mais rápida e Piloto do Dia.`)
};

const ja_f1_points_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファンタジーポイントは毎週末の複数セッションで付与されます：予選、レース、スプリント（スプリント週末の場合）。各セッションはフィニッシュ順位に応じてポイントを付与し、オーバーテイク、ファステストラップ、ドライバー・オブ・ザ・デイのボーナスがあります。`)
};

const zh_f1_points_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`梦幻积分在每个比赛周末的多个环节中获得：排位赛、正赛和冲刺赛（冲刺赛周末）。每个环节根据完赛位置奖励积分，另有超车、最快圈速和当日最佳车手奖励。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_points_how_p1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_points_how_p1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_points_how_p1", locale)
	if (locale === "en") return en_f1_points_how_p1(inputs)
	if (locale === "es") return es_f1_points_how_p1(inputs)
	if (locale === "de") return de_f1_points_how_p1(inputs)
	if (locale === "nl") return nl_f1_points_how_p1(inputs)
	if (locale === "fr") return fr_f1_points_how_p1(inputs)
	if (locale === "it") return it_f1_points_how_p1(inputs)
	if (locale === "pt-BR") return pt_br2_f1_points_how_p1(inputs)
	if (locale === "pt") return pt_f1_points_how_p1(inputs)
	if (locale === "ja") return ja_f1_points_how_p1(inputs)
	return zh_f1_points_how_p1(inputs)
};